jQuery(document).foundation(); 